module.exports = __webpack_public_path__ + "media/images/massage/main_image2-e893eafbd4a6a200386f8eae9ec2628a.jpg";